// src/features/learner/components/Navigation/UnitNavigation.js
import React from 'react';
import { InternalPagination } from './InternalPagination';
import './UnitNavigation.css';

export const UnitNavigation = ({
    currentIndex,
    internalIndex,
    totalUnits,
    internalContent,
    completedUnits,
    currentContent,
    visitedPages,
    visitedUnits,
    onPrevUnit,
    onNextUnit,
    onGoToInternal,
    onMarkPageVisited,
    hideUnitArrows = false
}) => {
    const showInternalPagination = internalContent && internalContent.length > 1;
    const canGoPrevUnit = currentIndex > 0;
    const canGoNextUnit = currentIndex < totalUnits - 1;

    const arrowStyle = (enabled) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        border: 'none',
        backgroundColor: enabled ? '#19a4a0' : '#dee2e6',
        color: enabled ? '#ffffff' : '#adb5bd',
        fontSize: '22px',
        cursor: enabled ? 'pointer' : 'not-allowed',
        flexShrink: 0,
        transition: 'background-color 0.2s',
        WebkitTapHighlightColor: 'transparent'
    });

    return (
        <div style={{
            position: 'sticky',
            bottom: 0,
            backgroundColor: '#fff',
            borderTop: '1px solid #dee2e6',
            padding: '8px 16px 12px',
            zIndex: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px'
        }}>

            {/* Level 1: Prev arrow */}
            {!hideUnitArrows && (
                <button
                    onClick={onPrevUnit}
                    disabled={!canGoPrevUnit}
                    aria-label="Previous unit"
                    style={arrowStyle(canGoPrevUnit)}
                >
                    ◀
                </button>
            )}

            {/* Level 2: Internal pagination — centre */}
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                {showInternalPagination && (
                    <InternalPagination
                        internalContent={internalContent}
                        currentIndex={internalIndex}
                        visitedPages={visitedPages}
                        visitedUnits={visitedUnits}
                        completedUnits={completedUnits}
                        currentContent={currentContent}
                        currentContentId={currentContent?.id}
                        onGoToIndex={onGoToInternal}
                        onMarkPageVisited={onMarkPageVisited}
                    />
                )}
            </div>

            {/* Level 1: Next arrow */}
            {!hideUnitArrows && (
                <button
                    onClick={onNextUnit}
                    disabled={!canGoNextUnit}
                    aria-label="Next unit"
                    style={arrowStyle(canGoNextUnit)}
                >
                    ▶
                </button>
            )}

        </div>
    );
};